import { lazy } from 'react';
import { createRoute } from '@tanstack/react-router';

import CompactLayout from 'src/layouts/compact';

import { rootRoute } from './root';

const ForgotPasswordPage = lazy(
  () => import('src/sections/auth/forgot-password/forgot-password-view')
);

// We got to here
export const forgotPasswordRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: 'forgot-password',
  component: () => <CompactLayout><ForgotPasswordPage/></CompactLayout>,
});
